var _path, _path2, _ellipse, _circle, _circle2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYourTeamMember(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 62,
    viewBox: "0 0 128 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.1447 9.48024L2.72342 34.5765C1.90153 34.9179 1.90154 36.0821 2.72343 36.4235L63.1447 61.5198C63.8846 61.8271 64.7167 61.8257 65.4556 61.5159L125.301 36.4222C126.118 36.0793 126.118 34.9207 125.301 34.5778L65.4556 9.48413C64.7167 9.17433 63.8846 9.17293 63.1447 9.48024Z",
    fill: "#D2D2D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1447 7.48024L2.72342 32.5765C1.90153 32.9179 1.90154 34.0821 2.72343 34.4235L63.1447 59.5198C63.8846 59.8271 64.7167 59.8257 65.4556 59.5159L125.301 34.4222C126.118 34.0793 126.118 32.9207 125.301 32.5778L65.4556 7.48413C64.7167 7.17433 63.8846 7.17293 63.1447 7.48024Z",
    fill: "white",
    stroke: "#090C10",
    strokeOpacity: 0.08
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 34.5,
    rx: 20,
    ry: 5.5,
    fill: "#FFF4CF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.75,
    cy: 17.5,
    r: 16.75,
    fill: "white",
    stroke: "#CB0000",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.25,
    cy: 25,
    r: 8,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.25 34.5C72.9333 34.5 71.696 34.25 70.538 33.75C69.3793 33.25 68.375 32.575 67.525 31.725C66.675 30.875 66 29.8707 65.5 28.712C65 27.554 64.75 26.3167 64.75 25C64.75 23.6833 65 22.4457 65.5 21.287C66 20.129 66.675 19.125 67.525 18.275C68.375 17.425 69.3793 16.75 70.538 16.25C71.696 15.75 72.9333 15.5 74.25 15.5C75.5667 15.5 76.8043 15.75 77.963 16.25C79.121 16.75 80.125 17.425 80.975 18.275C81.825 19.125 82.5 20.129 83 21.287C83.5 22.4457 83.75 23.6833 83.75 25C83.75 26.3167 83.5 27.554 83 28.712C82.5 29.8707 81.825 30.875 80.975 31.725C80.125 32.575 79.121 33.25 77.963 33.75C76.8043 34.25 75.5667 34.5 74.25 34.5ZM74.25 33C76.4833 33 78.375 32.225 79.925 30.675C81.475 29.125 82.25 27.2333 82.25 25C82.25 22.7667 81.475 20.875 79.925 19.325C78.375 17.775 76.4833 17 74.25 17C72.0167 17 70.125 17.775 68.575 19.325C67.025 20.875 66.25 22.7667 66.25 25C66.25 27.2333 67.025 29.125 68.575 30.675C70.125 32.225 72.0167 33 74.25 33Z",
    fill: "#CB0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2002 29.75H73.7002V25.75H69.7002V24.25H73.7002V20.25H75.2002V24.25H79.2002V25.75H75.2002V29.75Z",
    fill: "#CB0000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourTeamMember);
export default __webpack_public_path__ + "static/media/your-team-member.3f4bf4c2462e292e36a13df40c85ca0c.svg";
export { ForwardRef as ReactComponent };